import Login from "../Pages/Login";

const PublicRoutes = {
  path: "/",
  element: <Login />,
};

export default PublicRoutes;
 